import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Z4() {
    const { useLang, useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [progressAni, setProgressAni] = useState('');

    useEffect(() => {
        AniContainer.create({
            triggerElement: `.${css.d2xZ4} .progress-box`,
            triggerHook: 1,
            offset: '10%',
            onEnter() {
                setProgressAni('progress-ani');
            },
            onLeave() {
                setProgressAni('');
            },
        });
    }, []);

    return (
        <div className={`d2x-Z4 ${css.d2xZ4} GtmModuleData-section`} data-section-id={css.d2xZ4} data-section-title={t('sec4_title')}>
            <div className="sec4">
                <div className="text-box">
                    <p className="title">{t('sec4_title')}</p>
                    <p className="desc">
                        {t.rich('sec4_text', {
                            green: (text: string) => <span className="green">{text}</span>,
                        })}
                    </p>
                </div>
                <div className="img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z4.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z4.jpg')}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
                <div className="progress-box">
                    <div className="left-box">
                        <div className="delta2max">{t('sec4_d2x')}</div>
                        <div className="others">{t('sec4_others')}</div>
                    </div>
                    <div className="right-box">
                        <div className="top">
                            <div className="t-l">
                                <div className="t-l-t">
                                    <div className={`progress-inner ${progressAni}`}></div>
                                </div>
                                <div className="t-l-b">{t('sec4_gas')}</div>
                            </div>
                            <div className="t-r">
                                <div className="t-r-t">{t('sec4_num1')}</div>
                                <div className="t-r-b">{t('sec4_cycles')}</div>
                            </div>
                        </div>
                        <div className="bottom">
                            <div className="b-l">
                                <div className="b-l-t">
                                    <div className={`progress-inner ${progressAni}`}></div>
                                </div>
                                <div className="b-l-b">{t('sec4_ps')}</div>
                            </div>
                            <div className="b-r">
                                <div className="b-r-t">{t('sec4_num2')}</div>
                                <div className="b-r-b">{t('sec4_cycles')}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {locale === 'cn' && <p className="sec4-memo">{t('sec4_memo')}</p>}
            </div>
        </div>
    );
}
